import { Feature, Map } from "ol";
import { useEffect } from "react";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import { PRIMARY_COLOR } from "../../styles";
import Geometry from "ol/geom/Geometry";
import { fromExtent } from "ol/geom/Polygon";
import { useVectorLayer } from "../utils/useVectorLayer";

export function useBBoxLayer(map: Map | null, feature: Feature | null) {
	const { source } = useVectorLayer(map, {
		zIndex: Infinity,
		style: () =>
			new Style({
				stroke: new Stroke({
					color: PRIMARY_COLOR,
					width: 1,
					lineDash: [4, 4],
				}),
			}),
	});

	useEffect(() => {
		const geom = feature?.getGeometry();

		if (geom instanceof Geometry) {
			source.addFeature(
				new Feature({
					geometry: fromExtent(geom.getExtent()),
				}),
			);
		}

		return () => {
			source.clear();
		};
	}, [source, feature]);
}
